<template lang="pug">
  .crew-member
    .name {{p.first}}, {{p.last}}
    .member-details(v-if="p.code") 
      span.member-code {{p.code}}
      span(v-if="p.ssn")
        span.member-ssn &nbsp;&middot; SSN:  {{p.ssn.slice(-4)}}
    .member-state(v-if="member_state == 'break'") {{on_break}} - {{member_elapsed}}
    .member-state(v-else-if="member_state == 'absent'") {{absent}}
    .member-state(v-else) {{working}} - {{member_elapsed}}

</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

const seconds_to_display = (seconds, trim_seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  const secs = Math.floor(seconds - hours * 3600 - minutes * 60);

  function padTo2(number) {
    if (number <= 99) {
      number = ("0" + number).slice(-2);
    }
    return number;
  }
  if (trim_seconds) {
    return padTo2(hours) + ":" + padTo2(minutes);
  } else {
    return padTo2(hours) + ":" + padTo2(minutes) + ":" + padTo2(secs);
  }
};

export default {
  name: "CrewMember",
  props: {
    p: null
  },
  data: function() {
    return {
      now: null
    };
  },
  computed: {
    ...mapState(["timer_map", "language"]),
    working() {
      if (this.language == "en") return "Working";
      else return "Trabajando";
    },
    on_break() {
      if (this.language == "en") return "On Break";
      else return "Tomando un descanso";
    },
    absent() {
      if (this.language == "en") return "Not present";
      else return "No presente";
    },
    member_state() {
      if (this.p) {
        const m = this.timer_map.get(this.p._id);
        if (m) return m.state;
      }
      return "absent";
    },
    member_elapsed() {
      const n = this.now; // eslint-disable-line no-unused-vars
      const m = this.timer_map.get(this.p._id);
      if (m) {
        const seconds = moment().diff(moment(m.time), "seconds");
        return seconds_to_display(seconds);
      } else {
        return "--:--";
      }
    }
  },
  mounted: function() {
    setInterval(() => {
      this.now = moment();
    }, 1000);
  },
  methods: {}
};
</script>

<style scoped lang="less">
.name {
  font-size: larger;
}
.working {
  .member-state {
    color: green;
  }
}
.absent {
  .member-state {
    color: rgb(155, 32, 32);
  }
}
.break {
  .member-state {
    color: rgb(116, 96, 8);
  }
}
.member-state {
  font-weight: bold;
}

.member-code {
  font-family: monospace;
}
</style>
